import * as Cookies from 'js-cookie';
import {getCurrentDomain} from '../../context-utils';
import {DATA_NOPUSH, logger} from '../constants';
import {isAHWebSite} from '../../helpers';

export function getEnv() {
  let env = 'staging';
  const cHw2h = Cookies.get('_Hw2h_');
  if (cHw2h && typeof cHw2h == 'string' && cHw2h.length > 0 && cHw2h.match(/\.(evy|elr)\d{1}[a-d]/)) {
    env = 'production';
  }
  return env;
}

export function getDeviceType() {
  const val = Cookies.get('deviceType');
  return (val) ? val : '';
}

export function getCountryMarket() {
  let cm = Cookies.get('userLocalization');
  if (!cm || cm == '""') {
    cm = Cookies.get('userPrefLocalization');
  }
  return (cm) ? cm : '';
}


export function getBrandContext() {
  let brandContext = '';
  if (getCurrentDomain().brandName) {
    brandContext = getCurrentDomain().brandName;
    brandContext = brandContext.toUpperCase();
  }
  return brandContext;
}

export function updateDataWithCookieValueAndDeleteIt(datas, gtmAttributename, cookiename) {
  const cookieValue = Cookies.get(cookiename);
  if (cookieValue) {
    datas[gtmAttributename] = cookieValue;
  }
  deleteCookie(cookiename);
}

export function deleteCookie(name) {
  logger(name, "test remove cookie")
  if (typeof name != undefined && name) {
    const domain = '.' + getCurrentDomain().rootHostname;
    Cookies.remove(name, { path: '/', domain: domain });
  }
}

export function getSourceFromReferrer() {
  const referrer = document.referrer;
  let val = '';
  if (referrer == '') {
    val = 'DIRECT_ACCESS';
  } else if (!isAHWebSite(referrer)) {
    val = 'REFERRALS';
  } else {
    // Referrer is a ah web site
    // eslint-disable-next-line no-console
    logger('## TagManager - REFERRER IS AH WEBSITE');
  }
  return val;
}

export function saveToDatas(obj, src) {
  const datas = obj || {};
  const sources = src || {};
  for (const prop in sources) {
    if (sources[prop]) {
      datas[prop] = sources[prop];
    }
  }
  return datas;
}

export function isB2B(userData) {
  let isB2B = false;
  
  const subscriptionCardProduct = userData?.loyalty?.subscriptionCards?.card[0]?.cardProduct || null;
  if(subscriptionCardProduct && typeof subscriptionCardProduct?.productLabel !='undefined' && (subscriptionCardProduct?.productLabel === 'ALL PLUS ibis' || subscriptionCardProduct?.productLabel === 'ALL PLUS Voyageur')) {
      isB2B = true;
  }

  return isB2B;
}

export function isNoPush() {
  const isBodyPresent = document.body != null;
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isNoPush - isBodyPresent', isBodyPresent);
  const isNoPush = (isBodyPresent && document.body.getAttribute(DATA_NOPUSH) === '1');
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isNoPush - found nopush attribute', isNoPush);
  return isNoPush;
}


export function isTrackUser() {
  const isBodyPresent = document.body != null;
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isNoPush - isBodyPresent', isBodyPresent);
  const isNoPush = (isBodyPresent && document.body.getAttribute('data-gtmdisabletrackuser') === '1');
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isNoPush - found nopush attribute', isNoPush);
  return isNoPush;
}


export function getGTMId() {
  const val =  Cookies.get('gtmId');
  return (val) ? val : 'GTM-TKQN7D';
}

export function getUserId() {
  const val = Cookies.get('UAUID');
  return (val) ? val : '';
}

export function isBookingFunnelPage() {
  const reBooking = new RegExp(/^(\/ssr\/|\/store\/)/);
  const isBooking = reBooking.test(window.location.pathname);
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isBookingFunnelPage', isBooking);
  return isBooking;
}

export function isAutoTrackPageDisable() {
  let isDisable = false;
  const scriptEl = document.querySelector('script[data-disable-auto-trackpage]');
  if (scriptEl) {
    isDisable = /^(true|1)$|^$/.test(scriptEl.getAttribute('data-disable-auto-trackpage'));
  }
  // eslint-disable-next-line no-console
  logger('## Tagmanager - isAutoTrackPageDisable', isDisable);
  return isDisable;
}

export function checkAutoTrackPage() {
  const promise = new Promise((resolve) => {
    let autoTrackPage = true; // auto track page by default
    if (isAutoTrackPageDisable()) {
      autoTrackPage = false;
    }
    if (isBookingFunnelPage()) {
      autoTrackPage = false;
    }
    if (document.body != null) {
      if (isNoPush()) {
        autoTrackPage = false;
      } else {
        autoTrackPage &= true;
      }
      resolve(autoTrackPage);
    } else {
      // check on dom content loaded
      document.addEventListener('DOMContentLoaded', function() {
        if (isNoPush()) {
          autoTrackPage = false;
        } else {
          autoTrackPage &= true;
        }
        resolve(autoTrackPage);
      });
    }
  });
  return promise;
}

export function formatDate(d, m, y) {
  const dateFormatted = (d && m && y) ? d + '-' + m + '-' + y : '';
  return dateFormatted;
}

export function getPartnerIdValueFromCookie(partnerNameList) {
  let partnerValues = {};
  const domain = '.' + getCurrentDomain().rootHostname;
  const path = '/';
  const search = location.search.substring(1);
  const searchParams = new URLSearchParams(search);
  const partnerParams = Object.keys(partnerNameList);
  const whiteListParams = partnerParams.reduce( function (obj, key) {
    var value = searchParams.get(key);
    if (value) {
      if (partnerNameList[key] !== null) {
         if(new RegExp(partnerNameList[key]).test(value)) obj[key] = value
      } else {
        obj[key] = encodeURIComponent(value);
      }
    }
    return obj;
  }, {});

  for (const partnerName of Object.keys(partnerNameList)) {
    partnerValues[partnerName] = '';
    const partnerValue = whiteListParams[partnerName] || null;

    if (partnerValue && typeof partnerValue == 'string' && partnerValue.length > 0) {
      // eslint-disable-next-line no-console
      logger(`## TagManager - Found parameter ${partnerName} in url`);
      Cookies.set(partnerName, partnerValue, {
        domain: domain,
        path: path
      });
      partnerValues[partnerName] = partnerValue;
      // eslint-disable-next-line no-console
      logger(`## TagManager - Add data ${partnerName} with value ${partnerValue} to datalayer`);
    } else {
      const partnerCookieValue = Cookies.get(partnerName, {
        domain: domain,
        path: path
      });
      if (partnerCookieValue && typeof partnerCookieValue == 'string' && partnerCookieValue.length > 0) {
        // eslint-disable-next-line no-console
        logger(`## TagManager - Found data ${partnerName} with value ${partnerCookieValue} in cookie (${path}, ${domain})`);
        partnerValues[partnerName] = partnerCookieValue;
        // eslint-disable-next-line no-console
        logger(`## TagManager - Add data ${partnerName} with value ${partnerCookieValue} to datalayer`);
      }
    }
  }
  return partnerValues;
};

/**
 * Function that allow to hash Email string with SHA-256
*/
export async function hashCode (email) {
  const textAsBuffer = new TextEncoder().encode(email);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const digest = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return digest;
};